export const docsLocales = ["en", "zh-CN"] as const;

export type DocsLocale = (typeof docsLocales)[number];

export const docsLocaleLabels: Record<DocsLocale, string> = {
	en: "English",
	"zh-CN": "中文",
};

export const docsLocaleMetadata: Record<
	DocsLocale,
	{
		title: string;
		description: string;
		pageActionsLabel: string;
	}
> = {
	en: {
		title: "doteb Documentation",
		description:
			"doteb Documentation - Route, manage, and analyze your LLM requests across multiple providers with a unified API interface.",
		pageActionsLabel: "Page actions",
	},
	"zh-CN": {
		title: "doteb 中文文档",
		description:
			"doteb 中文文档 - 通过统一 API 在多个提供商之间路由、管理并分析你的 LLM 请求。",
		pageActionsLabel: "页面操作",
	},
};

export const defaultDocsLocale: DocsLocale = "en";
export const docsLocaleCookieName = "llmgateway_locale";

const localeAliases: Record<string, DocsLocale> = {
	en: "en",
	"en-us": "en",
	en_us: "en",
	zh: "zh-CN",
	"zh-cn": "zh-CN",
	zh_cn: "zh-CN",
	"zh-hans": "zh-CN",
	zh_hans: "zh-CN",
	cn: "zh-CN",
};

export function normalizeDocsLocale(
	locale: string | null | undefined,
): DocsLocale {
	if (!locale) {
		return defaultDocsLocale;
	}

	return localeAliases[locale.trim().toLowerCase()] ?? defaultDocsLocale;
}

export function getDocsBrowserLocale(languages: readonly string[]): DocsLocale {
	for (const language of languages) {
		const locale = normalizeDocsLocale(language);

		if (
			locale !== defaultDocsLocale ||
			language.toLowerCase().startsWith("en")
		) {
			return locale;
		}
	}

	return defaultDocsLocale;
}

export function getDocsOpenGraphLocale(locale: DocsLocale) {
	return locale === "zh-CN" ? "zh_CN" : "en_US";
}
